import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=057c6607&scoped=true"
import script from "./orderAdd.vue?vue&type=script&lang=js"
export * from "./orderAdd.vue?vue&type=script&lang=js"
import style0 from "./orderAdd.vue?vue&type=style&index=0&id=057c6607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057c6607",
  null
  
)

export default component.exports